module.exports = __webpack_public_path__ + "static/shape-one-d49efa1e98ce5a357c76925fbae16973.png";